import React from 'react'
import { IdentityManualCheckItem } from './IdentityManualCheckItem';

export function IdentityManualCheckList({todos, onCheckHandler}) {
    const handler = async (id, done) => {
        await onCheckHandler(id,done)
    }


    const list = todos.map(item => {
        return <IdentityManualCheckItem
            todo={item}
            onCheckHandler={handler}
            key={item.uuid}
        />
    })
    
    return (
        <>
          {list}
        </>
    )
}
